/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2023, Zumper
 */

import { Flex } from '@chakra-ui/react'
import { Dots } from '@zcode-ui/loaders'
import React from 'react'

export const LoadingIndicator = () => {
  return (
    <Flex
      alignItems="center"
      background="gray.50"
      borderRadius="md"
      boxShadow="0px 2px 4px rgba(0, 0, 0, 0.16)"
      height="40px"
      justifyContent="center"
      width="80px"
    >
      <Dots height={10} />
    </Flex>
  )
}
